export default{
    //SCHEDULE INTERVIEW
    "question.error.refresh"               : "Pedimos desculpa, o intervalo de tempo que selecionou já não está disponível. Escolha outro intervalo de tempo abaixo",
    "question.error.char.exceeded"         : "O texto do comentário deve ter menos de 500 carateres.",
    
    "question.message.completed.1"         : "Obrigado por selecionar um horário para a entrevista. Enviámos um e-mail do endereço qual@surveyhealthcareglobal.com para confirmar a hora e a data da sua sessão.",
    "question.message.italic"              : "Pedimos-lhe que leia todas as instruções atentamente e entre em contacto com o gestor do projeto de reserva com quaisquer perguntas que possa ter.",
    "question.message.completed.2"         : "Os incentivos são creditados após a conclusão do projeto e o estudo pode ficar em campo durante várias semanas. O gestor do projeto de reserva poderá fornecer prazos mediante pedido.",
    "question.message.completed.3"         : "Contacto para cancelamento ou reagendamento: qual@surveyhealthcareglobal.com e faça referência ao seu número do projeto de confirmação.",
    "question.message.overquota.1"         : "Obrigado pelo seu interesse em participar hoje. Infelizmente, este estudo esgotou mais rapidamente do que o antecipado e não será possível aceitar respostas adicionais. Se esta situação alterar, iremos informá-lo(a). Estamos ansiosos por trabalhar consigo no futuro",
    "question.message.overquota.2"         : "Obrigado pelo seu tempo e cooperação.",
    "question.message.error"               : "Pode haver um problema com a finalização da sua marcação. Entre em contacto com o nosso gestor do projeto de reserva ao enviar um e-mail para qual@surveyhealthcareglobal.com e faça referência ao n.º do projeto no seu convite.",
    "minutes" : "minutos",

    // NEW OR ADDED FROM OTHER FILES OR CONST
    "select.time.for.interview"            : "Selecione uma hora para a sua entrevista",
    "all.times.are.in"                     : "Todos os horários estão em <>.",
    "question.time_slots.none"             : "Nenhum dos horários listados acima é conveniente para mim. Vou especificar a minha disponibilidade abaixo.",
    "question.comments"                    : "Comentários",
    "scheduler.link.submit"                : "Enviar",
    "question.text_placeholder"            : "Responda aqui..",
    // MONTHS
    "January"                              : "janeiro",
    "February"                             : "fevereiro",
    "March"                                : "março",
    "April"                                : "abril",
    "May"                                  : "maio",
    "June"                                 : "junho",
    "July"                                 : "julho",
    "August"                               : "agosto",
    "September"                            : "setembro",
    "October"                              : "outubro",
    "November"                             : "novembro",
    "December"                             : "dezembro",
    // DAYS OF THE WEEK
    "Monday"                               : "Segunda-feira",
    "Tuesday"                              : "Terça-feira",
    "Wednesday"                            : "Quarta-feira",
    "Thursday"                             : "Quinta-feira",
    "Friday"                               : "Sexta-feira",
    "Saturday"                             : "Sábado",
    "Sunday"                               : "Domingo",
    
    // OPEN SLOTS
    "open.slots"                           : "horários abertos"
}

//“Terça-feira, 19 de julho”.